import type { ThreadKind } from './types.ts';

export const KIND_FA: Record<ThreadKind, string> = {
  CHAT_APP: 'چت آنلاین · اپ',
  CHAT_SITE: 'چت آنلاین · سایت',
  TICKET: 'تیکت',
};

export const STATUS_FA: Record<string, string> = {
  CHAT: 'گفتگو',
  OPEN: 'شروع شده',
  WAITING_AGENT: 'منتظر پاسخ ما',
  ESCALATED: 'ارجاع‌شده',
  WAITING_USER: 'پاسخ داده شد',
  RESOLVED: 'حل‌شده',
  CLOSED: 'بسته',
};

export const PRIORITY_FA: Record<string, string> = {
  LOW: 'کم',
  NORMAL: 'عادی',
  HIGH: 'مهم',
  URGENT: 'فوری',
};

export const CATEGORY_FA: Record<string, string> = {
  ACCOUNT: 'حساب کاربری',
  KYC: 'احراز هویت',
  TOMAN_DEPOSIT: 'واریز تومان',
  TOMAN_WITHDRAWAL: 'برداشت تومان',
  CRYPTO_DEPOSIT: 'واریز رمزارز',
  CRYPTO_WITHDRAWAL: 'برداشت رمزارز',
  CONVERT: 'خرید و تبدیل',
  BANK_ACCOUNTS: 'حساب‌های بانکی',
  FEES_RATES: 'کارمزد و نرخ',
  SECURITY: 'امنیت',
  NETWORK_TXID: 'شبکه و TXID',
  NOTIFICATIONS: 'اعلان‌ها',
  PRIVACY: 'حریم خصوصی',
  OTHER: 'سایر',
};

export const KYC_FA: Record<string, string> = {
  NONE: 'بدون احراز',
  KYC1: 'سطح ۱',
  KYC2: 'سطح ۲',
  NOT_STARTED: 'شروع نشده',
  IN_PROGRESS: 'در جریان',
  CHECKING: 'در حال بررسی',
  VERIFIED: 'تأییدشده',
  NEEDS_CORRECTION: 'نیاز به اصلاح',
  TEMPORARILY_UNAVAILABLE: 'موقتاً در دسترس نیست',
  REJECTED: 'ردشده',
  PENDING: 'در انتظار',
};

export const ACCOUNT_FA: Record<string, string> = {
  ACTIVE: 'فعال',
  SUSPENDED: 'معلق',
  LOCKED: 'قفل',
  BLOCKED: 'مسدود',
};

export const TX_FA: Record<string, string> = {
  TOMAN_DEPOSIT: 'واریز تومان',
  TOMAN_WITHDRAWAL: 'برداشت تومان',
  CRYPTO_DEPOSIT: 'واریز رمزارز',
  CRYPTO_WITHDRAWAL: 'برداشت رمزارز',
  CONVERSION: 'تبدیل',
  SECURITY: 'رویداد امنیتی',
  SUPPORT: 'پشتیبانی',
};

export const TX_STATUS_FA: Record<string, string> = {
  SUBMITTED: 'ثبت‌شده',
  UNDER_REVIEW: 'در حال بررسی',
  APPROVED_CREDITED: 'تأیید و واریز شد',
  REJECTED: 'ردشده',
  CANCELLED: 'لغوشده',
  OTP_PENDING: 'منتظر کد تأیید',
  EXPIRED: 'منقضی',
  PROCESSING: 'در حال انجام',
  SECURITY_HOLD: 'توقف امنیتی',
  SETTLEMENT_UNCERTAIN: 'تسویه نامشخص',
  COMPLETED: 'انجام شد',
  REJECTED_REFUNDED: 'رد و برگشت داده شد',
  AWAITING_TXID: 'منتظر TXID',
  TXID_SUBMITTED: 'TXID ثبت شد',
  CREDITED: 'واریز شد',
  INFO: 'اطلاع',
  WARNING: 'هشدار',
  CRITICAL: 'بحرانی',
  ...STATUS_FA,
};

export const SECURITY_EVENT_FA: Record<string, string> = {
  REGISTERED: 'ثبت‌نام',
  LOGIN_SUCCESS: 'ورود موفق',
  LOGIN_FAILED: 'ورود ناموفق',
  NEW_DEVICE_LOGIN: 'ورود از دستگاه جدید',
  PASSWORD_CHANGED: 'تغییر رمز',
  PASSWORD_RESET: 'بازیابی رمز',
  TOTP_ENABLED: 'فعال‌سازی ورود دومرحله‌ای',
  TOTP_DISABLED: 'غیرفعال‌سازی ورود دومرحله‌ای',
  SESSION_REVOKED: 'خروج از یک نشست',
  OTHER_SESSIONS_REVOKED: 'خروج از نشست‌های دیگر',
  PHONE_CHANGED: 'تغییر موبایل',
  KYC1_SUBMITTED: 'ارسال احراز سطح ۱',
  KYC1_VERIFIED: 'تأیید احراز سطح ۱',
  KYC2_SUBMITTED: 'ارسال احراز سطح ۲',
  BANK_INSTRUMENT_VERIFIED: 'تأیید کارت/حساب',
};

/** Starting points the agent edits before sending (chat-friendly tone). */
export const CANNED: { label: string; text: string }[] = [
  { label: 'سلام', text: 'سلام، وقت‌تان بخیر. در خدمت‌تان هستم؛ لطفاً بفرمایید.' },
  {
    label: 'در حال بررسی',
    text: 'ممنون از صبرتان. در حال بررسی هستم و تا چند دقیقه‌ی دیگر نتیجه را همین‌جا می‌گویم.',
  },
  {
    label: 'کد پیگیری',
    text: 'لطفاً کد پیگیری تراکنش (یا TXID) و زمان تقریبی انجامش را بفرستید تا دقیق بررسی کنم.',
  },
  { label: 'رسید', text: 'لطفاً تصویر رسید بانکی یا صفحه‌ی تراکنش را از دکمه‌ی پیوست بفرستید.' },
  {
    label: 'ورود به حساب',
    text: 'برای بررسی جزئیات حساب، لطفاً وارد حساب هوپکس شوید و از بخش «پشتیبانی» داخل اپ پیام بدهید تا هویت‌تان تأیید باشد.',
  },
  {
    label: 'هشدار امنیتی',
    text: 'یادآوری مهم: پشتیبانی هوپکس هرگز رمز عبور، کد پیامکی یا عبارت بازیابی کیف پول از شما نمی‌خواهد.',
  },
  {
    label: 'پایان',
    text: 'خوشحالیم که مشکل برطرف شد. اگر سؤال دیگری داشتید، همین‌جا در خدمت‌تان هستیم.',
  },
];
